import { FC, ReactNode } from 'react';
import { Accordion } from '@kpa/kul';
import XhtmlTextBlock from '../XhtmlTextBlock';
import { AccordionBlockResponse } from '../../types/blocks';

interface IAccordionBlock {
  content: AccordionBlockResponse;
}

const AccordionBlock: FC<IAccordionBlock> = ({ content }): ReactNode => {
  return (
    <Accordion panelHeading={content.rubrik} panelHeadingLevel={3} contentHeadingLevel={1} contentHeading="">
      <XhtmlTextBlock xhtmlTextBlockResponse={content.xhtml} />
    </Accordion>
  );
};

export default AccordionBlock;
